import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { processReq } from "../../helpers/processRequest";
import { GET, POST, PUT } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";

const init = {
    user: {},
    userList: [],
    loading: {},
    error: null
};

export const userSlice = createSlice({
    name: "userSlice",
    initialState: init,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },

        setUsers: (state, action) => {
            state.userList = action.payload;
        },

        setError: (state, action) => {
            state.error = action.payload;
        },

        clearData: (state) => {
            return init;
        },
    },
    extraReducers: (builder) => {
        builder
        // Fetch user list
        .addCase(fetchUserList.pending, (state) => {
            state.loading.fetching = true;
            state.error = null;
        })
        .addCase(fetchUserList.fulfilled, (state, action) => {
            state.loading.fetching = false;
            state.userList = action.payload;
        })
        .addCase(fetchUserList.rejected, (state, action) => {
            state.loading.fetching = false;
            state.error = action.payload;
        })

        // Add user
        .addCase(addUser.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(addUser.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.user = action.payload;
        })
        .addCase(addUser.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        })

        // Update user
        .addCase(updateUser.pending, (state) => {
            state.loading.saving = true;
            state.error = null;
        })
        .addCase(updateUser.fulfilled, (state, action) => {
            state.loading.saving = false;
            state.user = action.payload;
        })
        .addCase(updateUser.rejected, (state, action) => {
            state.loading.saving = false;
            state.error = action.payload;
        });
    }
});

export const fetchUserList = createAsyncThunk(
    "userSlice/fetchUserList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await processReq(GET, `${API_ROUTE}/users`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to fetch user list");
        }
    }
);

export const updateUser = createAsyncThunk(
    "userSlice/updateUser",
    async ({ userId, userData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(PUT, `${API_ROUTE}/users/${userId}`, userData);
            dispatch(fetchUserList());

            return response.data;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to update user");
        }
    }
);

export const addUser = createAsyncThunk(
    "userSlice/addUser",
    async ({ userData }, { rejectWithValue, dispatch }) => {
        try {
            const response = await processReq(POST, `${API_ROUTE}/users`, userData);
            dispatch(fetchUserList());

            return response.data;
        } catch (error) {
            return rejectWithValue(error.toString() || "Failed to add user");
        }
    }
);

export const { clearData, setUser, setUsers, setError } = userSlice.actions;

export default userSlice.reducer;
